import React from 'react';
import cn from 'classnames';
import DaVideoPlayer from '../components/DaVideoPlayer';
import { useSize } from '../hooks/useSize';
import s from './Viewer.scss';
const Viewer = ({ node })=>{
    var _node_extensionConfig;
    const attrs = node.attrs;
    const config = (_node_extensionConfig = node.extensionConfig) === null || _node_extensionConfig === void 0 ? void 0 : _node_extensionConfig.daVideo;
    const { alignment } = attrs;
    var _config_defaultHeight;
    const { width, height } = useSize(config.defaultWidth, (_config_defaultHeight = config.defaultHeight) !== null && _config_defaultHeight !== void 0 ? _config_defaultHeight : 100, attrs.alignment, node.containerWidth);
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "video",
        "data-da-type": "da-video",
        "data-src": attrs.src,
        className: cn(s['video-wrapper'], s[alignment], (config === null || config === void 0 ? void 0 : config.smallMedia) && s['small-media'])
    }, /*#__PURE__*/ React.createElement(DaVideoPlayer, {
        src: attrs.src,
        width: width,
        height: height
    }));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map